export * from '@fhs/routing/src/routes/redeem/_layout';
export { default } from '@fhs/routing/src/routes/redeem/_layout';
